const SELECTED_MODIFIER = '--selected';
const PUBLISHED_PREFIX = 'published_';
const GBP_STRING = 'gbp';
const CONTEXT_KEYS = {
  currencyKey: 'currency',
  variantKey: 'variant',
  cartIdKey: 'cartId',
  cartDataKey: 'cartData',
  selectedAddressKey: 'selectedAddress'
};
const ADDDRESS_LOADED_KEY = 'addressLoaded';
const LOCAL_CART_KEY = 'blaze_cart_id';
const LOCAL_CURRENCY_KEY = 'blaze_cart_currency_code';
const BLAZE_DEFAULT_MIN_QUANTITY = 1;

const EVENT_NAMES = {
  begin_checkout: 'begin_checkout',
  add_payment_info: 'add_payment_info',
  purchase: 'purchase',
  view_cart: 'view_cart',
  view_cart_review: 'view_cart_review',
  view_checkout_button: 'view_checkout_button',
  view_item: 'view_item'
};

export {
  ADDDRESS_LOADED_KEY,
  BLAZE_DEFAULT_MIN_QUANTITY,
  SELECTED_MODIFIER,
  CONTEXT_KEYS,
  LOCAL_CART_KEY,
  LOCAL_CURRENCY_KEY,
  PUBLISHED_PREFIX,
  GBP_STRING,
  EVENT_NAMES
};
